import i18n from '@/i18n/i18n'
const { t } = i18n.global

export const PAYMENT_STATUS_TYPE = {
  PAYABLE: 1,
  WORKFLOWS_NOT_COMPLETED: 2,
  FUTURE_DATED: 3,
  BLOCKED: 4
}

export const PAYMENT_STATUS_TYPE_MAP = {
  1: t('views.admin.pending_retailer_payments.payable'),
  2: t('views.admin.pending_retailer_payments.workflows_not_done'),
  3: t('views.admin.pending_retailer_payments.future_dated'),
  4: t('views.admin.pending_retailer_payments.blocked')
}

export const PAYMENT_STATUS_TYPE_BADGE = {
  1: 'primary-lighten',
  2: 'danger-lighten',
  3: 'danger-lighten',
  4: 'danger-lighten'
}
